"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.LAYOUT3_TYPE = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _gerenciatdUnifiedcomponents = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.text-info"));
var _gerenciatdUtils = require("@bit/gerenciatd.utils.common");
var _gerenciatdUnifiedcomponents2 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.button"));
var _gerenciatdUnifiedcomponents3 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.promo-strip-extended"));
var _gerenciatdUnifiedcomponents4 = _interopRequireDefault(require("@bit/gerenciatd.unifiedcomponents.custom-link"));
var _bannerUtils = require("../../bannerUtils");
require("./layout3.scss");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const LAYOUT3_TYPE = {
  FUSION: 'fusion',
  DISTRIBUTIVA: 'distributiva'
};
exports.LAYOUT3_TYPE = LAYOUT3_TYPE;
const Layout3 = props => {
  const finalProps = (0, _gerenciatdUtils.setUpPropsByDevice)(props);
  const {
    components,
    idBanner,
    type,
    mainTaggingInfo,
    fullClickable
  } = finalProps;
  let fullLink = '';
  let fullTaggingInfo = null;
  let forceExternal = false;
  let target;
  /* Extraemos el link del button-1 */
  if (components && components['Button-1'] && components['Button-1'].link && mainTaggingInfo) {
    fullLink = components['Button-1'].link;
    forceExternal = components['Button-1'].forceExternal ? components['Button-1'].forceExternal : false;
    fullTaggingInfo = mainTaggingInfo;
    target = components['Button-1'].target;
  }

  // Tratamiento fondo del banner
  (0, _bannerUtils.generateBgAndProperties)(idBanner, components, 'Layout3');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: "banner layout3",
    children: [components['PromoStripExtended-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "promostrip",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents3.default, {
          components: components['PromoStripExtended-1']
        })
      })
    }), fullLink && fullTaggingInfo && fullClickable && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents4.default, {
      className: "zIndex-1",
      isBlockElement: true,
      link: fullLink,
      target: target,
      forceExternal: forceExternal,
      taggingInfo: fullTaggingInfo
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      id: idBanner,
      className: `upgrade-section upgrade-section--${type} upgrade-section__height--${type}`,
      children: [components['TextInfo-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-1']), {}, {
        className: `title--${type} textInfo1`
      })), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "subtitle",
        children: components['TextInfo-2'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents.default, _objectSpread(_objectSpread({}, components['TextInfo-2']), {}, {
          className: `upgrade-section__subtitle--${type} textInfo2`
        }))
      }), components['Button-1'] && /*#__PURE__*/(0, _jsxRuntime.jsx)(_gerenciatdUnifiedcomponents2.default, _objectSpread(_objectSpread({}, components['Button-1']), {}, {
        className: `upgrade-section__button upgrade-section__button--${type}`,
        taggingInfo: mainTaggingInfo
      }))]
    })]
  });
};
Layout3.propTypes = {
  type: _propTypes.default.oneOf([LAYOUT3_TYPE.FUSION, LAYOUT3_TYPE.DISTRIBUTIVA])
};
Layout3.defaultProps = {
  type: LAYOUT3_TYPE.FUSION
};
var _default = Layout3;
exports.default = _default;

//# sourceMappingURL=index.js.map